import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'edcom-ui';
import style from './CollectionsModalCreate.module.less';
import clsx from 'clsx';
import '../../../edcom-ui/styles/forms-base.less';

export default function CollectionsModalCreate({ createCollection, showList }) {
  const [name, setName] = useState('');
  const [notEmpty, setNotEmpty] = useState(false);
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    if (!name) setNotEmpty(false);
    else setNotEmpty(true);
  }, [name]);

  const handleChangeName = event => {
    setName(event.target.value);
  };

  const handleFocus = () => {
    setFocus(true);
    setNotEmpty(true);
  };

  const handleBlur = () => {
    setFocus(false);
    setNotEmpty(name?.length > 0);
  };

  return (
    <>
      <h2>Create new collection</h2>

      <div className="form">
        <div className="input-row">
          <label
            className={clsx(
              'floating',
              { focus: focus },
              { 'not-empty': notEmpty }
            )}
          >
            <span>Collection name</span>
            <input
              name="title"
              type="text"
              value={name}
              maxLength={30}
              onChange={handleChangeName}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </label>
        </div>
      </div>

      <div className={style.actions}>
        <Button className={style.button} onClick={() => createCollection(name)}>
          Save
        </Button>
        <Button className={style.button} color="secondary" onClick={showList}>
          Cancel
        </Button>
      </div>
    </>
  );
}

CollectionsModalCreate.propTypes = {
  createCollection: PropTypes.func,
  showList: PropTypes.func,
};
